import AbsSection from './AbsSection';

export default class SecOst extends AbsSection {
    constructor(_container='', _dataM={}, _option={}){
        super(_container, _dataM, _option, 'ost');
        // console.log(this);

        if( this.isShow ) {
            let titleTmpl = `<img src="${_option.thumbnail}" class="main-official-thumb" alt="">${_option.title}`;
            $(_container + ' .title-link').prepend(titleTmpl);
            if( this.useManualData ){
                // this.dataM.addManual(this.alias, this.com.ip + '_mainOfficia');
                this.dataM.addCall(this.alias, {path: "/v1/videos/main?" + $.param({videoIds: _option.manualDataIds.join()})});
            } else {
                this.dataM.addCall(this.alias, {path: "/v1/videos/main/ost?" + $.param({game: this.com.ip, page: 1, pageSize:4})});
            }
        }
    }

    setTemplate(){
        let cardData = this.dataM.data.ost;
        if(typeof cardData === 'string'){
            console.log(cardData);
            $(this.container).hide();
            return false;
        }
        let list = cardData.map( (item, idx) => this.cardItemTmpl(item, this.alias, 'B') ).join('');
        $( this.container + ' .main-section-body .main-official-list' ).html( list );
    }

} // end of class
